import styled from 'styled-components';

export const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
  margin: 1rem auto;

  .hefesto-link {
    text-decoration: underline;
    font-size: 1rem;
    font-weight: bold;
  }
`;
